import React, { useState,useEffect } from 'react';
import './Home.css';
import Header from './Header';
import Sidebar from './Sidebar';
import MainContent from './MainContent';
import { useGlobalState } from '../state';
import { useLocation } from 'react-router-dom';
import AppLogout from './AppLogout'

function HomeForm() {
 
const location = useLocation();

  const [studentInfo, setStudentInfo] = useState(null);
  const [jsonObj, setJsonObj] = useState({});
  const [activeTab, setActiveTab] = useState("assessments");
  const [AcceleratedLearning, setAcceleratedLearning] = useState(false);

  console.log("Test environment deployment")

  useEffect(() => {
    try {
      // Try getting from navigation state first
      if (location.state) {
        const parsed = JSON.parse(location.state);
        sessionStorage.setItem("HomeFormData", JSON.stringify(parsed));
        setJsonObj(parsed);
      } else {
        // Fallback to sessionStorage after reload
        const stored = sessionStorage.getItem("HomeFormData");
        if (stored) setJsonObj(JSON.parse(stored));
      }
    } catch (err) {
      console.error("Error parsing data:", err);
    }
  }, [location.state]);

  const DOB = jsonObj?.DOB || "N/A";
  const defaultModule = jsonObj?.data?.defaultModule || "";
  const showAcceleratedLearning = jsonObj?.data?.showAcceleratedLearning || false;

  useEffect(() => {
    // Update AcceleratedLearning and tab when jsonObj changes
    setAcceleratedLearning(showAcceleratedLearning);

    let selectedTab = "assessments";
    if (defaultModule === "LION") selectedTab = "lion";
    else if (defaultModule) selectedTab = "results";

    setActiveTab(selectedTab);
  }, [defaultModule, showAcceleratedLearning]);

  const studentName = sessionStorage.getItem("FullName");


  return (   
    <AppLogout>
    <div className="app-container">
      <Header studentName={studentName} Sdata={jsonObj} studentInfo={studentInfo} />
      <div className="body-container">
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} AcceleratedLearning={AcceleratedLearning}/>
        <MainContent activeTab={activeTab} DOB={jsonObj.DOB} setStudentInfo={setStudentInfo} />
      </div>
    </div>
    </AppLogout>
  );
}

export default HomeForm;
